import { z } from 'zod';
import { IsoDateTime } from './common';

export const SetupItemKey = z.enum(['costs', 'printer', 'filament', 'channel']);
export type SetupItemKey = z.infer<typeof SetupItemKey>;

export const SetupStatus = z
  .object({
    items: z
      .array(z.object({ key: SetupItemKey, done: z.boolean(), detail: z.string().nullable() }))
      .describe(
        'The four things Quick Quote needs: costs (energy tariff and rates), a printer, a priced filament, a channel.',
      ),
    readyToQuote: z.boolean(),
    business: z
      .enum(['done', 'skipped', 'pending'])
      .describe('Optional step 1 (business data for PDFs and receipts).'),
    completedAt: IsoDateTime.nullable().describe('When the setup wizard was finished.'),
  })
  .meta({ id: 'SetupStatus' });
export type SetupStatus = z.infer<typeof SetupStatus>;
